const app = {
  namespaced: true,
  state: {
    /* C类贸易 */
    // 最终受益人信息
    cShareHoldInfo: {
      name: '',
      idType: '',
      idNo: ''
    },
    /* D类电商 */
    dShareHoldInfo: {
      name: '',
      idType: '',
      idNo: ''
    }
    // 可用币种列表
    // availableCoinList: []
  },
  mutations: {
    SET_C_SHARE_HOLD_INFO (state, info) {
      state.cShareHoldInfo = info
    },
    SET_D_SHARE_HOLD_INFO (state, info) {
      state.dShareHoldInfo = info
    }
    // SET_AVAILABLE_COIN_LIST (state, list) {
    //   state.availableCoinList = list
    // }
  },
  actions: {
  }
}

export default app
